export default "__VITE_ASSET__BNiKZp6A__"